import type { PropsWithChildren } from "react";
import styles from "./PdpActions.module.css";

export const PdpActions = ({ children }: PropsWithChildren) => {
	return <div className={styles.actions}>{children}</div>;
};
